Array.prototype.firstOrDefault = function(defaultValue = undefined) {
    return this.length > 0 ? this[0] : defaultValue;
}

Array.prototype.lastOrDefault = function(defaultValue = undefined) {
    return this.length > 0 ? this[this.length - 1] : defaultValue;
}

Number.prototype.gt = function(value) {
    return this > value;
}

Number.prototype.gte = function(value) {
    return this >= value;
}

Number.prototype.lt = function(value) {
    return this < value;
}

Number.prototype.lte = function(value) {
    return this <= value;
}

Number.prototype.e = function(value) {
    return this == value;
}

Number.prototype.se = function(value) {
    return this === value;
}

Number.prototype.intDiv = function(divisor) {
    return (this - (this % divisor)) / divisor;
}

Number.prototype.toFormat = function(configurations = {}) {
    const { prefix, suffix, precision, decimalSeparator, thousandSeparator } = configurations;
    let integerPart = this.intDiv(1);
    let decimalPart = ((this - integerPart).toFixed(precision || 0)).toString().substring(2).padEnd(precision || 0, '0').toString();
    let intergerText = `${integerPart}`
    intergerText = intergerText.padStart(intergerText.length + ((intergerText.length % 3 > 0) ? (3 - (intergerText.length) % 3) : 0), ' ').chunk(3).join(thousandSeparator || ',').trim()
    return  `${(prefix || "")}${intergerText}${decimalPart ? (decimalSeparator || '.') : ''}${decimalPart}${(suffix || "")}`
}

String.prototype.e = function(value) {
    return this == value;
}

String.prototype.se = function(value) {
    return this === value;
}

String.prototype.chunk = function(size) {
    return this.match(new RegExp('.{1,' + size + '}', 'g'));
}

String.prototype.lowerIndexOf = function(compareString) {
    return this.toLowerCase().indexOf(compareString.toLowerCase())
}

Object.clone = function(object) { 
    return JSON.parse(JSON.stringify(object)); 
}

Object.chain = function(obj, ...props) {
    if(props.length == 0) 
        return obj;

    if(props.length == 1) 
        return obj[props[0]] || undefined;

    return props.reduce((c, p, i) => {
        if(c == undefined && i > 0) {
            return c;
        }
        return c[p] || undefined
    }, obj);
}

export default {
    Array,
    Number,
    String,
    Object
}